import CopyIcon from '../../../assets/Modals/CopyIcon';
import ShareIcon from '../../../assets/Modals/ShareIcon';
import TrashIcon from '../../../assets/Modals/TrashIcon';
import { ChatMessageType } from '../../../services/apiTypes';
import { IconWrapper, LeftContainer, LeftText, RightContainer, RightText, SelectionHeaderContainer } from './styles';

type SelectionHeaderProps = {
  selectedMessages: ChatMessageType[];
  cancelSelection: () => void;
}

export default function SelectionHeader({ selectedMessages, cancelSelection }: SelectionHeaderProps) {
  return (
    <SelectionHeaderContainer>
      <LeftContainer>
        <LeftText>{selectedMessages.length} selecionadas</LeftText>
      </LeftContainer>
      <RightContainer>
        <IconWrapper>
          <CopyIcon />
        </IconWrapper>
        <IconWrapper>
          <ShareIcon />
        </IconWrapper>
        <IconWrapper>
          <TrashIcon />
        </IconWrapper>
        <RightText onClick={cancelSelection}>Cancelar</RightText>
      </RightContainer>
    </SelectionHeaderContainer>
  );
}